<template>
  <div class="ks-bottom-editor">
    <div class="ks-bottom-editor-tabs">
      <div style="overflow-x: auto;">
        <k-tabs v-model="selected_tab">
          <k-tab v-for="tab in filtered_tabs" :key="tab.href" :label="tab.title" :name="tab.name" :disabled="isDisabled(tab)"></k-tab>
        </k-tabs>
      </div>
      <div>
        <k-btn size="m" no-margin icon  @click="toggleFullscreen">
          <k-icon size="m" v-if="$root.bottomSheetFullscreen">fullscreen_exit</k-icon>
          <k-icon size="m" v-else>fullscreen</k-icon>
        </k-btn>
      </div>
      <div>
        <k-btn size="m" no-margin icon @click="closeEditor">
          <k-icon size="m" @click="closeEditor">close</k-icon>
        </k-btn>
      </div>
    </div>

    <div v-for="tab in filtered_tabs" :key="tab.name" v-show="tab.name == selected_tab" class="ks-bottom-editor-content">
      <component :is="tab.component" :id="id" :data="data"></component>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    id: {
      default: undefined
    },
    data: {
      default: undefined
    },
    tabs: {
      type: Array,
      default: [],
      required: true
    },
    'default-tab': String
  },
  computed: {
    filtered_tabs () {
      return this.tabs.filter(tab => {
        return (tab.admin_only && this.$is_admin()) || !tab.admin_only;
      });
    },
    selected_tab: {
      get() {
        return this.$route.query.tab || this.defaultTab;
      },
      set (val) {

        if(val == "__close_editor__") {
          this.$root.close_bottom_sheet();
        } else {
          this.$router.push({query: {...this.$route.query, tab: val}})
        }
      }
    },
  },
  methods: {
    get_tab(name) {
      return this.tabs.find(tab => tab.name == name);
    },
    toggleFullscreen() {
      this.$root.fullscreen_bottom_sheet();
    },
    closeEditor() {
      this.$root.close_bottom_sheet();
    },
    isDisabled (tab) {
      if(tab.edit_only && typeof(this.id) == "undefined") return true;
      if(tab.new_only && typeof(this.id) != "undefined") return true;
      return false;
    }
  }
}
</script>

<style>
.ks-bottom-editor {
  height: 100%;
  overflow: hidden;
  display: grid;
  grid-template-rows: auto 1fr;
}
.ks-bottom-editor-tabs {
  display: grid; 
  grid-template-columns: 1fr max-content max-content; 
  width: 100%;
  margin-bottom: var(--ks-margin-1);
}
.ks-bottom-editor-content {
  display: inherit;
  overflow: hidden;
}
</style>
